var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined")
    return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x + '" is not supported');
});
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/seam-connect/client.ts
import axios from "axios";
import axiosRetry from "axios-retry";

// src/lib/api-error.ts
var SeamAPIError = class extends Error {
  constructor(status, requestId, metadata) {
    var _a;
    super((_a = metadata == null ? void 0 : metadata.message) != null ? _a : "Unknown Error");
    this.status = status;
    this.requestId = requestId;
    this.metadata = metadata;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
  toString() {
    var _a, _b;
    return `SeamAPIError: ${this.status}, ${(_a = this.metadata) == null ? void 0 : _a.message} (${(_b = this.metadata) == null ? void 0 : _b.type})`;
  }
};
var SeamActionAttemptError = class extends Error {
  constructor(type, message, action_type) {
    super(`${type} performing ${action_type}: ${message}`);
    this.type = type;
    this.message = message;
    this.action_type = action_type;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
  toString() {
    return `SeamActionAttemptError: ${this.type} performing ${this.action_type}: ${this.message}`;
  }
};
var SeamMalformedInputError = class extends Error {
  constructor(validationErrors) {
    super(`Malformed input: ${JSON.stringify(validationErrors, null, 2)}`);
    this.validationErrors = validationErrors;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
  toString() {
    return `SeamMalformedInputError: ${JSON.stringify(
      this.validationErrors,
      null,
      2
    )}`;
  }
};

// src/seam-connect/routes.ts
import pRetry from "p-retry";
var Routes = class {
  constructor() {
    this.workspaces = {
      list: () => this.makeRequestAndFormat("workspaces", {
        url: "/workspaces/list"
      }),
      get: () => this.makeRequestAndFormat("workspace", {
        url: "/workspaces/get"
      }),
      resetSandbox: () => this.makeRequest({
        url: "/workspaces/reset_sandbox",
        method: "POST"
      })
    };
    this.locks = {
      list: (connectedAccountId) => this.makeRequestAndFormat("locks", {
        url: "/locks/list",
        params: connectedAccountId ? {
          connected_account_id: connectedAccountId
        } : {}
      }),
      get: (deviceId) => this.makeRequestAndFormat("lock", {
        url: "/locks/get",
        params: {
          device_id: deviceId
        }
      }),
      lockDoor: (deviceId) => this.createActionAttemptAndWait({
        url: "/locks/lock_door",
        data: {
          device_id: deviceId
        },
        method: "POST"
      }),
      unlockDoor: (deviceId) => this.createActionAttemptAndWait({
        url: "/locks/unlock_door",
        data: {
          device_id: deviceId
        },
        method: "POST"
      })
    };
    this.devices = {
      unmanaged: {
        get: (params) => this.makeRequestAndFormat("device", {
          url: "/devices/unmanaged/get",
          params
        }),
        list: (params) => this.makeRequestAndFormat("devices", {
          url: "/devices/unmanaged/list",
          params
        }),
        update: (params) => this.makeRequest({
          url: "/devices/unmanaged/update",
          method: "PATCH",
          data: params
        })
      },
      list: (params) => this.makeRequestAndFormat("devices", {
        url: "/devices/list",
        params
      }),
      listDeviceProviders: (params) => this.makeRequestAndFormat(
        "device_providers",
        {
          url: "/devices/list_device_providers",
          params
        }
      ),
      get: (params) => this.makeRequestAndFormat("device", {
        url: "/devices/get",
        params
      }),
      update: (params) => this.makeRequest({
        url: "/devices/update",
        method: "PATCH",
        data: params
      }),
      delete: (params) => this.makeRequest({
        url: "/devices/delete",
        method: "DELETE",
        params
      })
    };
    this.events = {
      list: (params) => {
        var _a;
        return this.makeRequestAndFormat("events", {
          url: "/events/list",
          method: "POST",
          data: __spreadProps(__spreadValues({}, params), {
            since: (_a = params == null ? void 0 : params.since) != null ? _a : (/* @__PURE__ */ new Date(0)).toISOString()
          })
        });
      },
      get: (params) => this.makeRequestAndFormat("event", {
        url: "/events/get",
        params
      })
    };
    this.connectWebviews = {
      list: () => this.makeRequestAndFormat(
        "connect_webviews",
        {
          url: "/connect_webviews/list"
        }
      ),
      get: (connectWebviewId) => this.makeRequestAndFormat("connect_webview", {
        url: "/connect_webviews/get",
        params: {
          connect_webview_id: connectWebviewId
        }
      }),
      create: (params) => this.makeRequestAndFormat(
        "connect_webview",
        {
          url: "/connect_webviews/create",
          method: "POST",
          data: params
        }
      ),
      delete: (params) => this.makeRequest({
        url: "/connect_webviews/delete",
        method: "DELETE",
        data: params
      })
    };
    this.accessCodes = {
      unmanaged: {
        delete: (params) => this.makeRequest({
          url: "/access_codes/unmanaged/delete",
          method: "DELETE",
          data: params
        }),
        get: (params) => this.makeRequestAndFormat(
          "access_code",
          {
            url: "/access_codes/unmanaged/get",
            params
          }
        ),
        list: (params) => this.makeRequestAndFormat(
          "access_codes",
          {
            url: "/access_codes/unmanaged/list",
            params
          }
        ),
        update: (params) => this.makeRequest({
          url: "/access_codes/unmanaged/update",
          method: "PATCH",
          data: params
        }),
        convertToManaged: (params) => this.createActionAttemptAndWait({
          url: "/access_codes/unmanaged/convert_to_managed",
          method: "PATCH",
          data: params
        })
      },
      list: (params) => this.makeRequestAndFormat("access_codes", {
        url: "/access_codes/list",
        params
      }),
      get: (params) => this.makeRequestAndFormat("access_code", {
        url: "/access_codes/get",
        params
      }),
      create: (params) => __async(this, null, function* () {
        return this.makeRequestAndFormat("access_code", {
          url: "/access_codes/create",
          method: "POST",
          data: params
        });
      }),
      createMultiple: (params) => __async(this, null, function* () {
        return this.makeRequestAndFormat(
          "access_codes",
          {
            url: "/access_codes/create_multiple",
            method: "POST",
            data: params
          }
        );
      }),
      generateCode: (params) => __async(this, null, function* () {
        return this.makeRequestAndFormat(
          "generated_code",
          {
            url: "/access_codes/generate_code",
            params
          }
        );
      }),
      // We can't narrow the return type here like we do with create because we're given partial input
      update: (params, options) => __async(this, null, function* () {
        const action = yield this.makeRequestAndFormat(
          "action_attempt",
          {
            url: "/access_codes/update",
            method: "POST",
            data: params
          }
        );
        if (options == null ? void 0 : options.waitForCompletion) {
          return yield this.awaitActionAttempt(action);
        }
        return action;
      }),
      delete: (params) => this.createActionAttemptAndWait({
        url: "/access_codes/delete",
        method: "POST",
        data: params
      }),
      pullBackupAccessCode: (params) => this.makeRequestAndFormat(
        "backup_access_code",
        {
          url: "/access_codes/pull_backup_access_code",
          method: "POST",
          data: params
        }
      )
    };
    this.connectedAccounts = {
      list: () => this.makeRequestAndFormat(
        "connected_accounts",
        {
          url: "/connected_accounts/list"
        }
      ),
      get: (params) => this.makeRequestAndFormat(
        "connected_account",
        {
          url: "/connected_accounts/get",
          params
        }
      ),
      delete: (params) => this.makeRequest({
        url: "/connected_accounts/delete",
        method: "DELETE",
        data: params
      })
    };
    this.actionAttempts = {
      get: (actionAttemptId) => this.makeRequestAndFormat("action_attempt", {
        url: "/action_attempts/get",
        params: {
          action_attempt_id: actionAttemptId
        }
      })
    };
    this.noiseThresholds = {
      list: (params) => this.makeRequestAndFormat(
        "noise_thresholds",
        {
          url: "/noise_sensors/noise_thresholds/list",
          params: {
            device_id: params.device_id
          }
        }
      ),
      create: (params) => this.makeRequest({
        url: "/noise_sensors/noise_thresholds/create",
        method: "POST",
        data: params
      }),
      update: (params) => this.makeRequest({
        url: "/noise_sensors/noise_thresholds/update",
        method: "POST",
        data: params
      }),
      delete: (params) => this.makeRequest({
        url: "/noise_sensors/noise_thresholds/delete",
        method: "DELETE",
        data: params
      })
    };
    this.webhooks = {
      list: () => this.makeRequestAndFormat("webhooks", {
        url: "/webhooks/list",
        params: {}
      }),
      get: (params) => this.makeRequestAndFormat("webhook", {
        url: "/webhooks/get",
        params
      }),
      create: (data) => this.makeRequest({
        url: "/webhooks/create",
        method: "POST",
        data
      }),
      delete: (params) => this.makeRequest({
        url: `/webhooks/delete`,
        method: "DELETE",
        params
      })
    };
    this.clientSessions = {
      create: (data) => this.makeRequestAndFormat(
        "client_session",
        {
          url: "/client_sessions/create",
          method: "POST",
          data
        }
      ),
      get: (params) => this.makeRequestAndFormat("client_session", {
        url: "/client_sessions/get",
        method: "GET",
        params
      }),
      getOrCreate: (data) => this.makeRequestAndFormat(
        "client_session",
        {
          url: "/client_sessions/get_or_create",
          method: "POST",
          data
        }
      ),
      list: (params) => this.makeRequestAndFormat("client_sessions", {
        url: "/client_sessions/list",
        method: "GET",
        params
      }),
      delete: (params) => this.makeRequest({
        url: "/client_sessions/delete",
        method: "DELETE",
        params
      })
    };
    this.deviceModels = {
      list: (_a = {}) => {
        var _b = _a, {
          acknowledge_intentional_use_of_internal_api = false
        } = _b, params = __objRest(_b, [
          "acknowledge_intentional_use_of_internal_api"
        ]);
        if (acknowledge_intentional_use_of_internal_api !== true) {
          throw new Error("This is an internal endpoint and should not be used.");
        }
        return this.makeRequestAndFormat(
          "device_models",
          {
            url: "/internal/device_models/list",
            params
          }
        );
      }
    };
    this.thermostats = {
      list: (params) => this.makeRequestAndFormat("thermostats", {
        url: "/thermostats/list",
        params
      }),
      get: (params) => this.makeRequestAndFormat("thermostat", {
        url: "/thermostats/get",
        params
      }),
      update: (params) => this.makeRequest({
        url: "/thermostats/update",
        method: "POST",
        data: params
      }),
      delete: (params) => this.makeRequest({
        url: "/thermostats/delete",
        method: "DELETE",
        params
      }),
      setFanMode: (params) => this.createActionAttemptAndWait({
        url: "/thermostats/set_fan_mode",
        method: "POST",
        data: params
      }),
      heat: (params) => this.createActionAttemptAndWait({
        url: "/thermostats/heat",
        method: "POST",
        data: params
      }),
      heatCool: (params) => this.createActionAttemptAndWait({
        url: "/thermostats/heat_cool",
        method: "POST",
        data: params
      }),
      cool: (params) => this.createActionAttemptAndWait({
        url: "/thermostats/cool",
        method: "POST",
        data: params
      }),
      off: (params) => this.createActionAttemptAndWait({
        url: "/thermostats/off",
        method: "POST",
        data: params
      }),
      climateSettingSchedules: {
        list: (params) => this.makeRequestAndFormat(
          "climate_setting_schedules",
          {
            url: "/thermostats/climate_setting_schedules/list",
            params
          }
        ),
        get: (params) => this.makeRequestAndFormat(
          "climate_setting_schedule",
          {
            url: "/thermostats/climate_setting_schedules/get",
            params
          }
        ),
        create: (data) => this.makeRequestAndFormat(
          "climate_setting_schedule",
          {
            url: "/thermostats/climate_setting_schedules/create",
            method: "POST",
            data
          }
        ),
        update: (params) => this.makeRequestAndFormat(
          "climate_setting_schedule",
          {
            url: "/thermostats/climate_setting_schedules/update",
            method: "POST",
            data: params
          }
        ),
        delete: (params) => __async(this, null, function* () {
          yield this.makeRequest({
            url: `/thermostats/climate_setting_schedules/delete`,
            method: "DELETE",
            params
          });
          return;
        })
      }
    };
  }
  awaitActionAttempt(actionAttempt) {
    return __async(this, null, function* () {
      let fetchedActionAttempt = actionAttempt;
      if (fetchedActionAttempt.status === "pending") {
        yield pRetry(
          () => __async(this, null, function* () {
            fetchedActionAttempt = yield this.actionAttempts.get(
              fetchedActionAttempt.action_attempt_id
            );
            if (fetchedActionAttempt.status === "pending") {
              throw new Error("Action attempt is still pending");
            }
          }),
          // @ts-expect-error UPSTREAM: https://github.com/DefinitelyTyped/DefinitelyTyped/commit/6f77b38130593a06e1988f1d3df162823ae186af#commitcomment-72928468
          { maxTimeout: 60 * 1e3 }
        );
      }
      if (fetchedActionAttempt.status === "error") {
        throw new SeamActionAttemptError(
          fetchedActionAttempt.error.type,
          fetchedActionAttempt.error.message,
          fetchedActionAttempt.action_type
        );
      }
      return fetchedActionAttempt;
    });
  }
  makeRequestAndFormat(innerObjectName, request) {
    return __async(this, null, function* () {
      const response = yield this.makeRequest(request);
      return response[innerObjectName];
    });
  }
  createActionAttemptAndWait(request) {
    return __async(this, null, function* () {
      const pendingActionAttempt = yield this.makeRequestAndFormat("action_attempt", request);
      const actionAttempt = yield this.awaitActionAttempt(pendingActionAttempt);
      return __spreadProps(__spreadValues({}, actionAttempt.result), {
        actionAttempt
      });
    });
  }
};

// package.json
var version = "8.22.1";

// src/lib/params-serializer.ts
var paramsSerializer = (params) => {
  const searchParams = new URLSearchParams();
  for (const [name, value] of Object.entries(params)) {
    if (value == null)
      continue;
    if (Array.isArray(value)) {
      if (value.length === 0)
        searchParams.set(name, "");
      if (value.length === 1 && value[0] === "") {
        throw new UnserializableParamError(
          name,
          `is a single element array containing the empty string which is unsupported because it serializes to the empty array`
        );
      }
      for (const v of value) {
        throwIfUnserializable(name, v);
        searchParams.append(name, v);
      }
      continue;
    }
    throwIfUnserializable(name, value);
    searchParams.set(name, value);
  }
  searchParams.sort();
  return searchParams.toString();
};
var throwIfUnserializable = (k, v) => {
  if (v == null) {
    throw new UnserializableParamError(k, `is ${v} or contains ${v}`);
  }
  if (typeof v === "function") {
    throw new UnserializableParamError(
      k,
      "is a function or contains a function"
    );
  }
  if (typeof v === "object") {
    throw new UnserializableParamError(k, "is an object or contains an object");
  }
};
var UnserializableParamError = class extends Error {
  constructor(name, message) {
    super(`Could not serialize parameter: '${name}' ${message}`);
    this.name = this.constructor.name;
    Error.captureStackTrace(this, this.constructor);
  }
};

// src/seam-connect/client.ts
var getSeamClientOptionsWithDefaults = (apiKeyOrOptions) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
  const providedOptions = typeof apiKeyOrOptions === "string" ? { apiKey: apiKeyOrOptions } : apiKeyOrOptions != null ? apiKeyOrOptions : {};
  return {
    apiKey: providedOptions.apiKey === null ? null : (_d = (_c = providedOptions.apiKey) != null ? _c : (_b = (_a = globalThis == null ? void 0 : globalThis.process) == null ? void 0 : _a.env) == null ? void 0 : _b.SEAM_API_KEY) != null ? _d : null,
    endpoint: (_h = (_g = providedOptions.endpoint) != null ? _g : (_f = (_e = globalThis == null ? void 0 : globalThis.process) == null ? void 0 : _e.env) == null ? void 0 : _f.SEAM_API_URL) != null ? _h : "https://connect.getseam.com",
    workspaceId: (_l = (_k = providedOptions.workspaceId) != null ? _k : (_j = (_i = globalThis == null ? void 0 : globalThis.process) == null ? void 0 : _i.env) == null ? void 0 : _j.SEAM_WORKSPACE_ID) != null ? _l : void 0,
    axiosOptions: (_m = providedOptions.axiosOptions) != null ? _m : {},
    clientSessionToken: providedOptions.clientSessionToken === null ? null : (_n = providedOptions.clientSessionToken) != null ? _n : null
  };
};
var Seam = class extends Routes {
  constructor(apiKeyOrOptions) {
    super();
    const { apiKey, endpoint, workspaceId, axiosOptions, clientSessionToken } = getSeamClientOptionsWithDefaults(apiKeyOrOptions);
    const authHeaders = getAuthHeaders({
      clientSessionToken,
      apiKey,
      workspaceId
    });
    const headers = __spreadValues(__spreadValues(__spreadValues({}, axiosOptions == null ? void 0 : axiosOptions.headers), authHeaders), !workspaceId ? {} : { "Seam-Workspace": workspaceId });
    if (typeof window === "undefined") {
      headers["User-Agent"] = `Javascript SDK v${version}, Node.js mode, (https://github.com/seamapi/javascript)`;
    }
    this.client = axios.create(__spreadProps(__spreadValues({
      withCredentials: clientSessionToken ? true : false
    }, axiosOptions), {
      baseURL: endpoint,
      paramsSerializer,
      headers
    }));
    axiosRetry(this.client, {
      retries: 2,
      retryDelay: axiosRetry.exponentialDelay
    });
  }
  makeRequest(request) {
    return __async(this, null, function* () {
      return makeRequest(this.client, request);
    });
  }
  static getClientSessionToken(options) {
    return __async(this, null, function* () {
      const { apiKey, endpoint, axiosOptions } = getSeamClientOptionsWithDefaults(options);
      if (!options.userIdentifierKey) {
        throw new Error("userIdentifierKey is required");
      }
      if (isEmail(options.userIdentifierKey)) {
        console.warn(`Using an email for the userIdentifierKey!
This is insecure because an email is common knowledge or easily guessed.
Use something with sufficient entropy known only to the owner of the client session (like a server-generated UUID).`);
      }
      const getKeyHeaders = () => {
        const { publishableKey } = options;
        if (publishableKey) {
          if (!publishableKey.startsWith("seam_pk")) {
            throw new Error("Invalid publishableKey");
          }
          return { "seam-publishable-key": publishableKey };
        }
        if (apiKey) {
          if (!(apiKey == null ? void 0 : apiKey.startsWith("seam_"))) {
            throw new Error("Invalid apiKey");
          }
          return { "seam-api-key": apiKey };
        }
        throw new Error("Must provide a publishableKey or apiKey");
      };
      const headers = __spreadValues(__spreadValues({}, getKeyHeaders()), axiosOptions == null ? void 0 : axiosOptions.headers);
      const client = axios.create(__spreadProps(__spreadValues({}, axiosOptions), {
        baseURL: endpoint,
        headers
      }));
      return makeRequest(client, {
        method: "POST",
        url: "/client_sessions/get_or_create",
        data: { user_identifier_key: options.userIdentifierKey }
      });
    });
  }
};
var isValueUsedForBearerAuthentication = (value) => value.startsWith("seam_at") || /** Exclude JWT tokens as well */
value.startsWith("ey");
var makeRequest = (client, request) => __async(void 0, null, function* () {
  var _a;
  try {
    const response = yield client.request(request);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      if (((_a = error.response.data.error) == null ? void 0 : _a.type) === "invalid_input") {
        throw new SeamMalformedInputError(
          error.response.data.error.validation_errors
        );
      }
      throw new SeamAPIError(
        error.response.status,
        error.response.headers["seam-request-id"],
        error.response.data.error
      );
    }
    throw error;
  }
});
var getAuthHeaders = ({
  clientSessionToken,
  apiKey,
  workspaceId
}) => {
  if (apiKey && clientSessionToken) {
    throw new Error("You can't use clientSessionToken AND specify apiKey.");
  }
  if (clientSessionToken) {
    if (!clientSessionToken.startsWith("seam_cst")) {
      throw new Error("clientSessionToken must start with seam_cst");
    }
    return {
      authorization: `Bearer ${clientSessionToken}`,
      "client-session-token": clientSessionToken
    };
  }
  if (apiKey) {
    if (apiKey.startsWith("seam_cst")) {
      throw new Error("You can't use a Client Session Token as an apiKey.");
    }
    if (!isValueUsedForBearerAuthentication(apiKey) && workspaceId)
      throw new Error(
        "You can't use API Key Authentication AND specify a workspace. Your API Key only works for the workspace it was created in. To use Session Key Authentication with multi-workspace support, contact Seam support."
      );
    return { authorization: `Bearer ${apiKey}` };
  }
  throw new Error(
    "Must provide either clientSessionToken or apiKey (API Key or Access Token with Workspace ID)."
  );
};
var isEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

// src/webhooks.ts
import { Webhook } from "svix";
var SeamWebhook = class {
  /**
   * Create a new instance of SeamWebhook.
   * @param secret your webhook secret from the dashboard
   */
  constructor(secret) {
    this.wh = new Webhook(secret);
  }
  /**
   * Verify a payload received from a webhook and return the typed event.
   * @param payload must be a string (should not be the parsed JSON object)
   * @param headers request headers (used to verify against the secret)
   * @returns event
   */
  verify(payload, headers) {
    return this.wh.verify(payload, headers);
  }
};

// src/types/models.ts
var LOCK_DEVICE_TYPES = [
  "akuvox_lock",
  "august_lock",
  "brivo_access_point",
  "butterflymx_panel",
  "avigilon_alta_entry",
  "doorking_lock",
  "genie_door",
  "igloo_lock",
  "linear_lock",
  "lockly_lock",
  "kwikset_lock",
  "nuki_lock",
  "salto_lock",
  "schlage_lock",
  "seam_relay",
  "smartthings_lock",
  "wyze_lock",
  "yale_lock",
  "two_n_intercom",
  "controlbyweb_device",
  "ttlock_lock",
  "igloohome_lock",
  "hubitat_lock",
  "four_suites_door",
  "dormakaba_oracode_door"
];
var NOISE_SENSOR_DEVICE_TYPES = [
  "noiseaware_activity_zone",
  "minut_sensor"
];
var THERMOSTAT_DEVICE_TYPES = [
  "nest_thermostat",
  "ecobee_thermostat",
  "honeywell_resideo_thermostat"
];
var NOISE_DETECTION_DEVICE_TYPES = NOISE_SENSOR_DEVICE_TYPES;
var PROVIDERS = [
  "akuvox",
  "august",
  "avigilon_alta",
  "brivo",
  "butterflymx",
  "schlage",
  "smartthings",
  "yale",
  "genie",
  "doorking",
  "salto",
  "lockly",
  "ttlock",
  "linear",
  "noiseaware",
  "nuki",
  "seam_relay_admin",
  "igloo",
  "kwikset",
  "minut",
  "my_2n",
  "controlbyweb",
  "nest",
  "igloohome",
  "ecobee",
  "hubitat",
  "four_suites",
  "dormakaba_oracode",
  "pti",
  "wyze"
];
var isLockDevice = (device) => {
  return LOCK_DEVICE_TYPES.includes(device.device_type);
};
var isNoiseSensorDevice = (device) => {
  return NOISE_SENSOR_DEVICE_TYPES.includes(device.device_type);
};
var isThermostatDevice = (device) => {
  return THERMOSTAT_DEVICE_TYPES.includes(device.device_type);
};

// src/seam-os/client.ts
import defaultAxios from "axios";
var getSeamOSClientOptionsWithDefaults = (apiKeyOrOptions) => {
  var _a, _b, _c;
  const seamClientDefaults = {
    apiKey: (_a = process == null ? void 0 : process.env) == null ? void 0 : _a.SEAM_API_KEY,
    endpoint: ((_b = process == null ? void 0 : process.env) == null ? void 0 : _b.SEAM_API_URL) || "https://example.com",
    organizationId: (_c = process == null ? void 0 : process.env) == null ? void 0 : _c.SEAM_ORGANIZATION_ID
  };
  if (typeof apiKeyOrOptions === "string") {
    return __spreadProps(__spreadValues({}, seamClientDefaults), { apiKey: apiKeyOrOptions });
  } else {
    return __spreadValues(__spreadValues({}, seamClientDefaults), apiKeyOrOptions);
  }
};
var SeamOS = class {
  constructor(apiKeyOrOptions) {
    this._curriedPost = (url) => (data) => {
      return this.post(url, data);
    };
    this._postGrab = (url, innerObject) => (data) => __async(this, null, function* () {
      const res = yield this.post(url, data);
      return res[innerObject];
    });
    this._getGrab = (url, innerObject) => (data) => __async(this, null, function* () {
      const res = yield this.post(url, data);
      return res[innerObject];
    });
    this._curriedGet = (url) => (data) => {
      return this.post(url, data);
    };
    this.organizations = {
      get: this._getGrab("/organizations/get", "organization"),
      list: this._getGrab("/organizations/list", "organizations"),
      create: this._postGrab("/organizations/create", "organization"),
      invite_user: this._curriedPost("/organizations/invite_user"),
      remove_user: this._curriedPost("/organizations/remove_user"),
      update: this._curriedPost("/organizations/update"),
      update_user_role: this._curriedPost("/organizations/update_user_role"),
      get_count_summary: this._postGrab(
        "/organizations/get_count_summary",
        "organization_counts"
      ),
      pending_users: {
        list: this._getGrab("/organizations/pending_users/list", "pending_users"),
        delete: this._curriedPost("/organizations/pending_users/delete"),
        resend_invitation: this._curriedPost(
          "/organizations/pending_users/resend_invitation"
        ),
        update: this._curriedPost("/organizations/pending_users/update")
      }
    };
    this.health = this._curriedGet("/health");
    this.access_codes = {
      create: this._postGrab("/access_codes/create", "access_code"),
      get: this._getGrab("/access_codes/get", "access_code"),
      list: this._getGrab("/access_codes/list", "access_codes"),
      delete: this._curriedPost("/access_codes/delete"),
      update: this._curriedPost("/access_codes/update")
    };
    this.access_passes = {
      create: this._postGrab("/access_passes/create", "access_pass"),
      get: this._getGrab("/access_passes/get", "access_pass"),
      get_count_summary: this._getGrab(
        "/access_passes/get_count_summary",
        "access_pass_counts"
      ),
      list: this._getGrab("/access_passes/list", "access_passes"),
      delete: this._curriedPost("/access_passes/delete"),
      list_accessible_devices: this._getGrab(
        "/access_passes/list_accessible_devices",
        "accessible_devices"
      )
      // update: this._curriedPost("/access_passes/update"),
    };
    this.buildings = {
      create: this._postGrab("/buildings/create", "building"),
      get: this._getGrab("/buildings/get", "building"),
      get_count_summary: this._getGrab(
        "/buildings/get_count_summary",
        "building_count_summary"
      ),
      list_count_summaries: this._getGrab(
        "/buildings/list_count_summaries",
        "building_count_summaries"
      ),
      list: this._getGrab("/buildings/list", "buildings"),
      delete: this._curriedPost("/buildings/delete"),
      update: this._curriedPost("/buildings/update"),
      add_device: this._curriedPost("/buildings/add_device"),
      add_user: this._curriedPost("/buildings/add_user"),
      update_user_role: this._curriedPost("/buildings/update_user_role"),
      remove_user: this._curriedPost("/buildings/remove_user")
    };
    this.events = {
      list: this._getGrab("/events/list", "events")
    };
    this.device_groups = {
      create: this._postGrab("/device_groups/create", "device_group"),
      get: this._getGrab("/device_groups/get", "device_group"),
      list: this._getGrab("/device_groups/list", "device_groups"),
      delete: this._curriedPost("/device_groups/delete"),
      update: this._curriedPost("/device_groups/update")
      // woops need to add
      // add_device: this._curriedPost("/device_groups/add_device"),
      // remove_device: this._curriedPost("/device_groups/remove_device"),
    };
    this.devices = {
      get: this._getGrab("/devices/get", "device"),
      list_counts: this._getGrab("/devices/list_counts", "device_counts"),
      list: this._getGrab("/devices/list", "devices"),
      delete: this._curriedPost("/devices/delete"),
      update: this._curriedPost("/devices/update"),
      get_count_summary: this._getGrab(
        "/devices/get_count_summary",
        "device_count_summary"
      )
    };
    this.incidents = {
      list: this._getGrab("/incidents/list", "incidents")
    };
    this.linked_accounts = {
      get: this._getGrab("/linked_accounts/get", "linked_account"),
      list: this._getGrab("/linked_accounts/list", "linked_accounts")
    };
    this.locks = {
      lock: this._curriedPost("/locks/lock"),
      unlock: this._curriedPost("/locks/unlock")
    };
    this.login_portals = {
      create: this._postGrab("/login_portals/create", "login_portal"),
      get: this._getGrab("/login_portals/get", "login_portal"),
      delete: this._curriedPost("/login_portals/delete")
    };
    this.user_groups = {
      create: this._postGrab("/user_groups/create", "user_group"),
      get: this._getGrab("/user_groups/get", "user_group"),
      list: this._getGrab("/user_groups/list", "user_groups"),
      update: this._curriedPost("/user_groups/update"),
      delete: this._curriedPost("/user_groups/delete"),
      add_user: this._curriedPost("/user_groups/add_user"),
      remove_user: this._curriedPost("/user_groups/remove_user")
    };
    this.users = {
      get: this._getGrab("/users/get", "user"),
      list: this._getGrab("/users/list", "users"),
      update: this._curriedPost("/users/update"),
      delete: this._curriedPost("/users/delete"),
      get_building_roles: this._getGrab(
        "/users/get_building_roles",
        "user_building_roles"
      ),
      list_organization_roles: this._getGrab(
        "/users/list_organization_roles",
        "user_organization_roles"
      )
    };
    const { apiKey, endpoint, organizationId, axiosOptions } = getSeamOSClientOptionsWithDefaults(apiKeyOrOptions);
    const isRegularAPIKey = apiKey == null ? void 0 : apiKey.startsWith("seam_");
    if (isRegularAPIKey && organizationId)
      throw new Error(
        "You can't use API Key Authentication AND specify a workspace. Your API Key only works for the workspace it was created in. To use Session Key Authentication with multi-workspace support, contact Seam support."
      );
    if (!apiKey) {
      throw new Error(
        "SEAM_API_KEY not found in environment, and apiKey not provided"
      );
    }
    this.axios = defaultAxios.create(__spreadProps(__spreadValues({}, axiosOptions), {
      baseURL: endpoint,
      headers: __spreadValues(__spreadProps(__spreadValues({}, axiosOptions == null ? void 0 : axiosOptions.headers), {
        Authorization: `Bearer ${apiKey}`,
        ["User-Agent"]: `Javascript SDK v${version} (https://github.com/seamapi/javascript)`
      }), !organizationId ? {} : { "Seam-Organization-Id": organizationId })
    }));
  }
  makeRequest(request) {
    return __async(this, null, function* () {
      const res = yield this.axios.request(request);
      return res.data;
    });
  }
  get(url, config) {
    return this.makeRequest(__spreadValues({ url, method: "GET" }, config));
  }
  post(url, data, config) {
    return this.makeRequest(__spreadValues({ url, method: "POST", data }, config));
  }
};

// src/seam-os/routes.ts
var routes_exports = {};

// src/index.ts
var src_default = Seam;

export {
  __require,
  __export,
  __async,
  SeamAPIError,
  SeamActionAttemptError,
  SeamMalformedInputError,
  getSeamClientOptionsWithDefaults,
  Seam,
  SeamWebhook,
  LOCK_DEVICE_TYPES,
  NOISE_SENSOR_DEVICE_TYPES,
  THERMOSTAT_DEVICE_TYPES,
  NOISE_DETECTION_DEVICE_TYPES,
  PROVIDERS,
  isLockDevice,
  isNoiseSensorDevice,
  isThermostatDevice,
  getSeamOSClientOptionsWithDefaults,
  SeamOS,
  routes_exports,
  src_default
};
//# sourceMappingURL=chunk-2XW6BNJ7.mjs.map